import * as defaultImport from "@splunk/visualizations/Image";
export * from "@splunk/visualizations/Image";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
